<div class="modal-overlay" *ngIf="url" (click)="closed.emit()">
  <div class="preview-content" role="dialog" aria-modal="true" [attr.aria-label]="alt" (click)="$event.stopPropagation()">
    <button type="button" class="close-preview-btn" (click)="closed.emit()" aria-label="Close preview">✖</button>
    <div class="preview-image-wrap">
      <img [src]="url" [alt]="alt" class="preview-image">
    </div>
    <div class="preview-side-panel" *ngIf="hasPanel">
      <ng-content></ng-content>
    </div>
  </div>
</div>
